
import { HttpRequestInterceptor } from './shared/interceptors/interceptor.module';
import { CommonModule, HashLocationStrategy, LocationStrategy} from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS,  } from '@angular/common/http';
import { NgModule, LOCALE_ID } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LanguageTranslationModule } from './shared/modules/language-translation/language-translation.module'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './shared';
import { HttpModule } from '@angular/http';
import { DocumentEditorModule } from '@txtextcontrol/tx-ng-document-editor';
import { registerLocaleData } from '@angular/common';
import localePt from '@angular/common/locales/pt';

registerLocaleData(localePt);

@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        HttpModule,
        LanguageTranslationModule,
        AppRoutingModule,
        DocumentEditorModule,
    ],
    declarations: [AppComponent],
    providers: [
        AuthGuard,
        HttpRequestInterceptor,
        { provide: LOCALE_ID, useValue: 'pt-BR' },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpRequestInterceptor,
            multi: true
        },
    ],
    bootstrap: [AppComponent]
})
export class AppModule {}
